import { useMutation, useQueryClient } from '@tanstack/react-query';
import { channelsApi } from '../services';

export const useAddUserToChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      channelId,
      userId,
      role,
      scope,
      priority,
      capabilities
    }: {
      channelId: string;
      userId: string;
      role: 'viewer' | 'attendant';
      scope?: 'own' | 'team' | 'all';
      priority?: number;
      capabilities?: string[];
    }) => channelsApi.addUserToChannel(channelId, { userId, role, scope, priority, capabilities }),

    onSuccess: (_, variables) => {
      // Invalidate channels list (usado em ChannelsPage - listagem com members)
      queryClient.invalidateQueries({ queryKey: ['channels'] });
      // Invalidate channel users list
      queryClient.invalidateQueries({ queryKey: ['channel-users', variables.channelId] });
      // Invalidate available users
      queryClient.invalidateQueries({ queryKey: ['available-users', variables.channelId] });
      // Invalidate operators stats
      queryClient.invalidateQueries({ queryKey: ['channel-operators-stats', variables.channelId] });
      // Invalidate channel operators (usado em OperatorsSection e LotteryConfigSection)
      queryClient.invalidateQueries({ queryKey: ['channel-operators', variables.channelId] });
    }
  });
};
